import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import {Button, LoadingIndicator} from '../../../components'
import {Container, Title} from '../../flow'
import TextField from 'material-ui/TextField'
import Grid from '../../../common/components/Grid'
import {addresses as text} from '../../profile/text'

const styles = (theme) => ({
  container: {maxWidth: 328, margin: '0 auto'},
  title: {marginBottom: 20},
  button: {margin: '30px 0 5px 0'},
})

class AddressStep extends React.Component {

  static displayName = 'AddressStep.component'

  render() {
    const {classes, add} = this.props
    const { emptyFieldErrors } = add

    return (
      <Container className={classes.container}>
        <Title className={classes.title}>¿Dónde retiraremos los ítems?</Title>

        <Grid container>
          <Grid item xs={12}>
            <TextField
              label={text.addDialog.labelAddress}
              autoFocus={true}
              fullWidth
              value={this.props.add.address}
              onChange={e => this.props.setAddress(e.target.value)}
              helperText={emptyFieldErrors.address}
              error={emptyFieldErrors.address.length > 0}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={text.addDialog.labelNumber}
              fullWidth
              value={this.props.add.number}
              onChange={e => this.props.setStreetNumber(e.target.value)}
              helperText={emptyFieldErrors.number}
              error={emptyFieldErrors.number.length > 0}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={text.addDialog.labelPostalCode}
              fullWidth
              value={this.props.add.postalCode}
              onChange={e => this.props.setPostalCode(e.target.value)}
              helperText={emptyFieldErrors.postalCode}
              error={emptyFieldErrors.postalCode.length > 0}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={text.addDialog.labelFloor}
              fullWidth
              value={this.props.add.floor}
              onChange={e => this.props.setFloor(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={text.addDialog.labelApartment}
              fullWidth
              value={this.props.add.apartment}
              onChange={e => this.props.setApartment(e.target.value)}
            />
          </Grid>
        </Grid>
        <div className={classes.button}>
          <LoadingIndicator show={this.props.isButtonLoading}>
            <Button
              variant={'primary'}
              fullWidth={true}
              onClick={() => this.props.continue()}
            >
              Continuar
            </Button>
          </LoadingIndicator>
        </div>
      </Container>
    )
  }

  static propTypes = {
    add: PropTypes.shape({
      address: PropTypes.string,
      number: PropTypes.string,
      floor: PropTypes.string,
      apartment: PropTypes.string,
      postalCode: PropTypes.string,
      emptyFieldErrors: PropTypes.shape({
        address: PropTypes.string,
        number: PropTypes.string,
        postalCode: PropTypes.string,
      })
    }),
    setAddress: PropTypes.func.isRequired,
    setFloor: PropTypes.func.isRequired,
    setApartment: PropTypes.func.isRequired,
    setPostalCode: PropTypes.func.isRequired,
    setStreetNumber: PropTypes.func.isRequired,
    isFormLoading: PropTypes.bool,
    isButtonLoading: PropTypes.bool,
    isButtonDisabled: PropTypes.bool,
    continue: PropTypes.func.isRequired,
    error: PropTypes.string,
  }
}

export default withStyles(styles, {withTheme: true})(AddressStep)



// WEBPACK FOOTER //
// ./src/sections/remove/components/address.step.jsx